module.exports = __webpack_public_path__ + "static/media/briefcase.4fb672bd.svg";